import BenefitsTabs from './BenefitsTabs';

export default BenefitsTabs;
